module.exports = __webpack_public_path__ + "static/img/14.d771915.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/14.png
// module id = H4C3
// module chunks = 0